window.addEventListener('load', () => {
  const targets = document.body.querySelectorAll('.js-eventTracking')
  window.dataLayer = window.dataLayer || []

  Array.from(targets).forEach(el => {
    const { eventCategory, eventAction, eventLabel } = el.dataset
    el.addEventListener('click', () => {
      window.dataLayer.push({
        event: 'event_tracking',
        event_category: eventCategory,
        event_action: eventAction,
        event_label: eventLabel,
      })
    })
  })
})
